<template>
  <section class="deliveryassociation">
    <f-card class="header">
      <section class="row wrap">
        <label class="label-group"><span>Fournisseur</span><div class="label">{{ computedSupplierLabel }}</div></label>
        <label class="label-group"><span>Date de livraison</span><div class="label">{{ deliveryDate }}</div></label>
        <label class="label-group"><span>N° bon de livraison</span><div class="label">{{ computedDeliveryCodes }}</div></label>
        <label class="label-group"><span>N° facture</span><div class="label">{{ billNumber }}</div></label>
        <label class="label-group">
          <span>Factures</span>
          <div class="label"><span>Voir les fichiers</span>
            <span class="file-btn" @click="showModal">
              <ab-icon class="upload" icon="file-upload" iconset="delivery"></ab-icon>
              <span v-show="files.length" class="count">{{ files.length ? files.length : null }}</span>
            </span>
          </div>
        </label>
        <label class="label-group"><span>Date de facture</span><div class="label">{{ BillDate }}</div></label>
        <label class="label-group-font flex">
          <span>Date de règlement</span>
          <div class="label" v-if="payment">
            <f-select
              placeholder="Règlement"
              trackBy="id"
              label="label"
              :showLabels="false"
              :options="payments"
              :searchable="false"
              v-model="payment"
              disabled>
            </f-select>
          </div>
          <div v-if="payment && payment.id == 1">
            <datepicker
              :monday-first="true"
              format="dd/MM/yyyy"
              placeholder="JJ/MM/AAAA"
              :language="fr"
              class="f-datepicker"
              v-model="paymentDate"
              disabled>
              <span slot="afterDateInput" class="bar"></span>
            </datepicker>
          </div>
        </label>
      </section>
    </f-card>
    <f-table>
      <template slot="table-header">
        <colgroup class="delivery" span="3">
          <col class="code">
          <col class="quantity">
          <col class="total">
        </colgroup>
        <colgroup class="bill" span="3">
          <col class="quantity-price">
          <col class="total">
          <col class="credit">
        </colgroup>
      </template>
      <template slot="colgroup">
      </template>
      <template slot="thead">
        <th class="center" colspan="3" scope="colgroup"><strong>Livraison</strong></th>
        <th class="center hightlight" colspan="3" scope="colgroup">Factures</th>
      </template>
      <template slot="tbody">
        <tr>
          <!-- Delivery -->
          <th>Designation / Code</th>
          <th>Qté / PU HT</th>
          <th class="right space"><strong>Total</strong></th>
          <!-- Bill -->
          <th class="center hightlight">Qté / PU HT</th>
          <th class="right hightlight">Total</th>
          <th class="right hightlight">DA</th>
        </tr>
        <tr class="product-row" v-for="(delivery, idx) in computedItems" :key="idx">
          <!-- Delivery -->
          <td>
            <div class="col"><span>{{ delivery.Product.label }}</span><span>{{ delivery.Product.code }}</span></div>
          </td>
          <td>
            <div class="col">
              <!-- FIXME : Decide if we display the received quanty if it differ from ordered quantity-->
              <span><strong>{{ delivery.quantity_received }}</strong> {{ delivery.Product.Conditioning.label_short }} à <strong>{{ delivery.price | currency }}</strong></span>
              <span class="qty-error" v-if="delivery.quantity_ordered != delivery.quantity_received">Différence entre quantité reçue et commandée.</span>
            </div>
          </td>
          <td class="right space">
            <div class="col total-prices">
              <strong>{{ delivery.price * delivery.quantity_received | currency }}</strong>
              <small class="txt-ternary">TTC: {{ delivery.total_ttc | currency }}</small>
            </div>
          </td>
          <!-- Bill -->
          <td>
            <div class="col">
              <div class="quantity-price flex flex-space">
                <ab-input class="quantity" v-model="delivery.billQuantity" :disabled="true"></ab-input>
                <span>{{ delivery.Product.Conditioning.label_short }}</span>
                <div class="price flex flex-space">
                  <ab-input v-model="delivery.billPrice" :disabled="true"></ab-input><span>€</span>
                </div>
              </div>
            </div>
          </td>
          <td class="right">
            <div class="col">
              <div class="price hightlight total-prices">
                <strong>{{ computeBillItemPriceHT(delivery) | currency }}</strong>
                <small class="txt-ternary">TTC: {{ computeBillItemPriceTTC(delivery) | currency }}</small>
              </div>
            </div>
          </td>
          <td class="credit flex flex-right">
            <f-checkbox :disabled="true" v-model="delivery.credit"></f-checkbox>
          </td>
        </tr>
      </template>
    </f-table>
    <section class="totals flex flex-right">
      <div class="ctn">
        <div class="flex flex-right">
          <div class="label">Total livraison <span class="tax">HT</span></div>
          <div class="amount">{{ totalHT | currency }}</div>
        </div>
        <div class="flex flex-right">
          <div class="label">Total livraison <span class="tax">TTC</span></div>
          <div class="amount">{{ totalTTC | currency }}</div>
        </div>
        <div class="flex flex-right hightlight">
          <div class="label">Total facturation <span class="tax">HT</span></div>
          <div class="amount">{{ totalBillHT - totalCreditReceived | currency }}</div>
        </div>
        <div class="flex flex-right hightlight">
          <div class="label">Total facturation <span class="tax">TTC</span></div>
          <div class="amount">{{ totalBillTTC - totalCreditReceived | currency }}</div>
        </div>
        <div class="flex flex-right">
          <div class="label">Total demande d'avoir <span class="tax">HT</span></div>
          <div class="amount">{{ totalCredit | currency }}</div>
        </div>
        <div class="flex flex-right hightlight">
          <div class="label">Total avoir reçu <span class="tax">HT</span></div>
          <div class="amount">{{ totalCreditReceived | currency }}</div>
        </div>
        <div class="footer flex flex-right">
          <router-link class="btn-action" :to="{ name: 'DeliveryList' }">Retour</router-link>
        </div>
      </div>
    </section>

    <!-- Upload files -->
    <f-modal class="modal" name="upload" height="auto">
      <section>
        <f-card>
          <main>
            <p>Télécharger une facture</p>
            <file-pond
              name="bills"
              ref="pond"
              :label-idle="pondLabel"
              :allow-multiple="true"
              :files="files"
              :max-files="5"
              :server="server"
              :allow-file-type-validation="true"
              :accepted-file-types="pondAcceptedFileType">
            </file-pond>
          </main>
          <footer class="flex flex-right">
            <ab-button class="primary" @click.native="$modal.hide('upload')">Fermer</ab-button>
          </footer>
        </f-card>
      </section>
    </f-modal>

    <ab-iconset iconset="delivery">
      <g id="file-upload"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path></g>
    </ab-iconset>
  </section>
</template>

<script>
import FCard from '@/components/layout/card/f-card.vue';
import AbIcon from '@/components/icon/ab-icon.vue';
import AbInput from '@/components/form/input/ab-input.vue';
import FTable from '@/components/layout/table/f-table.vue';
import FCheckbox from '@/components/form/input/f-checkbox.vue';
import AbButton from '@/components/form/button/ab-button.vue';
import AbIconset from '@/components/icon/ab-iconset.vue';
import Datepicker from 'vuejs-datepicker';
import { fr } from 'vuejs-datepicker/dist/locale';
import { mapState } from 'vuex';
// Import error message files
import messages from '@/messages/messages.js';
import notification from '@/components/mixins/notification.js';
// Import FilePond
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  name: 'DeliveryDetail',
  mixins: [ notification ],
  props: {
    isEdit: false
  },
  components: {
    AbButton,
    AbIcon,
    AbIconset,
    AbInput,
    Datepicker,
    FCard,
    FCheckbox,
    FTable,
    FilePond
  },
  async mounted() {
    const delivery = Array.isArray(this.$route.query.delivery) ? this.$route.query.delivery : [this.$route.query.delivery];

    await this.$store.dispatch('getDeliveriesToAssociateInBill', {
      client: this.$store.state.client,
      id: this.$route.params.id,
      full: true
    });
    if (this.deliveries.length > 0 && this.deliveries[0].length > 0) {
      this.billNumber = this.deliveries[0][0].Bill[0].code;
      this.deliveries[0][0].Bill[0].Document.forEach(document => {
        const root = process.env.VUE_APP_ROOT_API;
        this.files.push({
          id: document.id,
          source: `${root}${document.path}`,
          options: { type: 'local' }
        });
      });
    }
    await this.$store.dispatch('getPayments');
    await this.$store.dispatch('getTaxes');
  },
  data() {
    return {
      billNumber: '',

      billError: false,
      pondLabel: "Glissez vos documents ou <u>cliquez ici</u>",
      pondAcceptedFileType: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'],
      files: [],
      fr: fr,
      lastUploadedFile: [],
      server: {
        process: async(fieldName, file, metadata, load, error, progress, abort) => {
          if (this.lastUploadedFile.length > 0 && (typeof this.lastUploadedFile.find(e => e == file.name) !== 'undefined')) { abort(); return; }
          const formData = new FormData();

          const billId = this.deliveries[0][0].Bill[0].id;
          formData.append('fileUpload', file, file.name);

          const data = await this.$store.dispatch('uploadBillDocuments', { clientId: this.client, billId, data: formData });
          if (data) {
            const root = process.env.VUE_APP_ROOT_API;
            this.lastUploadedFile.push(file.name);
            this.files.push({
              id: data.id,
              source: `${root}${data.path}`,
              options: { type: 'local' }
            })
            load(data.id);
          } else {
            abort();
            this.displayToast({ message: "Une erreur est survenue", mode: 'error' });
          }
        },
        load: async(source, load, error, progress, abort, headers) => {
          const myRequest = new Request(source);
          fetch(myRequest).then(function(response) {
            response.blob().then(function(myBlob) {
              load(myBlob);
            });
          });
        }
      },
    };
  },
  computed: {
    ...mapState([ 'client' ]),
    ...mapState({ deliveries: state => state.deliveries.deliveriesToAssociate }),
    ...mapState({ payments: state => state.deliveries.payments }),
    ...mapState({ taxes: state => state.selectors.taxes }),
    deliveryDate() {
      if (this.deliveries.length > 0 && this.deliveries[0].length > 0) {
        return this.deliveries ? (new Date(this.deliveries[0][0].date)).toLocaleDateString('fr-FR') : '';
      }
    },
    BillDate() {
      if (this.deliveries.length > 0 && this.deliveries[0].length > 0) {
        return this.deliveries ? (new Date(this.deliveries[0][0].Bill[0].date)).toLocaleDateString('fr-FR') : '';
      }
    },
    payment() {
      if (this.deliveries.length > 0 && this.deliveries[0].length > 0 && this.deliveries[0][0].Payment) {
        return this.deliveries ? this.deliveries[0][0].Payment : '';
      }
    },
    paymentDate() {
      if (this.deliveries.length > 0 && this.deliveries[0].length > 0) {
        return this.deliveries ? (new Date(this.deliveries[0][0].payment_date)) : '';
      }
    },
    computedSupplierLabel() {
      if (this.deliveries.length > 0 && this.deliveries[0].length > 0) {
        return this.deliveries[0][0].Supplier.label;
      }
    },
    computedDeliveryCodes() {
      return this.deliveries.map(delivery => delivery[0]).map(el => {
        if (!el) return;
        return el.code;
      }).join(', ')
    },
    computedItems() {
      let deliveries = [];
      let deliveryArray;

      // In association mode, the delivery item is returned into a sub array
      deliveryArray = this.deliveries.map(delivery => delivery[0]);

      // Iterate through all the delivery to retreive all the items
      deliveryArray.map(delivery => {
        delivery.Delivery_form_data = delivery.Delivery_form_data.map((data) => {
          let billData;
          if (!('billPrice' in data)) {
            // Find the right item from the bill
            billData = delivery.Bill[0].Bill_data.find(item => {
              return item.delivery_form_data_id == data.id;
            });
            this.$set(data, 'billPrice', billData.price);
          }

          if(!('billTotalTTC' in data)) {
            if(!this.isEdit) {
              this.$set(data, 'billTotalTTC', data.total_ttc)
            } else {
              // Find the right item from the bill
              delivery.Bill[0].Bill_data.find(item => {
                return item.delivery_form_data_id == data.id;
              });
              this.$set(data, 'billTotalTTC', billData.total_ttc);
            }
          }

          if (!('billQuantity' in data)) {
            // Find the right item from the bill
            billData = delivery.Bill[0].Bill_data.find(item => {
              return item.delivery_form_data_id == data.id;
            });
            this.$set(data, 'billQuantity', billData.quantity);
          }
          if (data.quantity_ordered != data.quantity_received || billData && billData.da_active) data.credit = true;
          return data;
        });
        return deliveries = [ ...deliveries, ...delivery.Delivery_form_data ];
      });
      return deliveries;
    },
    totalHT() {
      if (this.computedItems.length > 0)
        return this.computedItems.map(item => this.computeItemPriceHT(item)).reduce((a, b) => Number(a._toFixed(2)) + Number(b._toFixed(2)));
      return 0.000;
    },
    totalTTC() {
      return this.calculateTTC('computeItemPriceHT');
    },
    totalBillHT() {
      if (this.computedItems.length > 0)
        return this.computedItems.map(item => this.computeBillItemPriceHT(item)).reduce((a, b) => Number(a._toFixed(2)) + Number(b._toFixed(2)));
      return 0.000;
    },
    totalBillTTC() {
      return this.calculateTTC('computeBillItemPriceHT');
    },
    total() {
      if (this.computedItems.length > 0)
        return this.computedItems.map(item => this.computeItemPrice(item)).reduce((a, b) => Number(a._toFixed(2)) + Number(b._toFixed(2)));
      return 0.000;
    },
    totalCredit() {
      if (this.computedItems.length > 0) {
        let creditArray = this.computedItems.filter(item => item.credit).map(item => (this.computeBillItemPriceHT(item) - this.computeItemPriceHT(item)));
        if (creditArray.length > 0)
          return creditArray.reduce((a, b) => a + b)
        return 0.000;
      }
      return 0.000;
    },
    totalCreditReceived() {
      if (this.deliveries.length > 0 && this.deliveries[0].length > 0 && this.deliveries[0][0].Bill) {
        return this.deliveries[0][0].Bill[0].total_da;
      }
      return 0.000;
    }
  },
  methods: {
    showModal() {
      this.$modal.show('upload');
    },
    handleFiles() {
      this.files = this.$refs.pond.getFiles();
      this.$modal.hide('upload');
    },
    computePriceHT(decimal = 2) {
      return Number(this.price) * this.quantity_ordered;
    },
    computePrice(decimal = 2) {
      if (this.Product.Tax == null) this.Product.Tax = { percentage: 0 };
      return (Number(this.price) + (this.price * (this.Product.Tax.percentage * 0.01))) * this.quantity_ordered;
    },
    computeItemPriceHT(item, decimal = 2) {
      return Number(item.price) * item.quantity_received;
    },
    computeItemPrice(item, decimal = 2) {
      if (item.Product.Tax == null) item.Product.Tax = { percentage: 0 };
      return (Number(item.price) + (item.price * (item.Product.Tax.percentage * 0.01))) * item.quantity_ordered;
    },
    computeBillItemPriceHT(item, decimal = 2) {
      return Number(item.billPrice) * item.billQuantity;
    },
    computeBillItemPriceTTC(item, decimal = 2) {
      const tax = this.taxes.find(tax => { return tax.id == item.Product.tax_id });
      return (item.billPrice * ((tax.percentage/100) + 1) ) * item.billQuantity;
    },
    computeBillItemPrice(item, decimal = 2) {
      if (item.Product.Tax == null) item.Product.Tax = { percentage: 0 };
      return (Number(item.billPrice) + (item.price * (item.Product.Tax.percentage * 0.01))) * item.billQuantity;
    },
    calculateTTC(method) {
      if (this.computedItems.length > 0) {
        // Group products by tax group
        // And sum all the (rounded) product by tax group
        const productGrouped = this.taxes.map(tax => {
          let taxGroup = {};
          taxGroup[tax.percentage] = this.computedItems
            .filter(item => item.Product.Tax.percentage == tax.percentage)
            .map(item => this[method](item))
            .reduce((sum, next) => {
              return Number(sum._toFixed(2)) + Number(next._toFixed(2));
            }, 0);
          return taxGroup;
        });
        // Iterate into taxes and add the percentage
        const total = productGrouped.map(group => {
          const keys = Object.keys(group);
          if (!keys[0]) return;
          const key = keys[0];
          const taxValue = (1 + (Number(key) / 100));
          const value = group[key] * taxValue;

          return Number(value._toFixed(2));
        }).reduce((sum, next) => sum + next, 0);

        return total;
      }
      return 0.000;
    },
    isCheckboxDisabled(delivery) {
      if (this.isEdit) return true;
      return delivery.credit ? !delivery.credit : this.computeBillItemPriceHT(delivery) <= delivery.price*delivery.quantity_received;
    },
    handleValidation() {
      if (this.isEdit) this.creditReceived();
      else this.associate();
    },
    async creditReceived() {
      const formData = new FormData();
      this.files.forEach(file => {
        if (!this.deliveries[0]) return;
        formData.append('fileUpload', file.file, file.file.name);
      });
      // FIXME: Silly !
      if (!this.deliveries[0] || !this.deliveries[0][0] || !this.deliveries[0][0].Bill[0]) return console.error('No bill');
      const billId = this.deliveries[0][0].Bill[0].id;
      const data = await this.$store.dispatch('uploadBillDocuments', { clientId: this.client, billId, data: formData });
      if (data) {
        const deliveryIds = this.deliveries.map(delivery => delivery[0]).map(delivery => delivery.id);
        const deliveries = {
          delivery_form: deliveryIds
        };
        this.$store.dispatch('creditReceived', { client: this.client, delivery: deliveries });
      }
      this.$router.push({ name: 'DeliveryList' });
    },
    async associate() {
      // Due to async behaviour, the deliveries array can still be empty when user try to do
      // the association
      if (!this.deliveries.length) return;

      // Reset all the required field error state
      // And display an error message if requirement not met
      this.billError = false;
      if (!this.billNumber.trim()) {
        this.billError = true;
        // console.error(messages.deliveries.global.custom.mandatory);
        this.displayToast({ message: messages.deliveries.global.custom.mandatory, mode: 'error' });
        return false;
      }

      const data = {
        code: this.billNumber,
        supplier: this.deliveries[0].Supplier.id,
        date: new Date(this.deliveries[0].date).getTime(),
        data : this.deliveries.map(delivery => {
          return {
            delivery_form: delivery.id,
            bill_datas: this.computedItems.map(item => {
              return {
                delivery_form_data: item.id,
                price: item.billPrice,
                quantity: item.billQuantity,
                da: 0,
                da_active: item.credit || false,
              };
            })
          };
        })
      };
      const formData = new FormData();
      formData.append('data', JSON.stringify(data));
      this.files.forEach(file => {
        formData.append(this.deliveries[0].id, file.file);
      });
      this.$store.dispatch('createDetailedAssociation', { client: this.client, deliveries: formData });

      const isCredit = data.data.some(item => {
        let credit = item.bill_datas.some(p => p.da_active);
        return credit;
      });

      const deliveryIds = Array.isArray(this.$route.query.delivery) ? this.$route.query.delivery : [this.$route.query.delivery];
      const deliveries = {
        delivery_form: deliveryIds
      };

      let result = false;
      if (isCredit) {
        result = await this.$store.dispatch('creditToReceive', { client: this.client, delivery: deliveries });
      } else {
        result = await this.$store.dispatch('closeDelivery', { client: this.client, delivery: deliveries });
      }
      if (result != false ) {
        this.displayToast({ message: messages.deliveries.DeliveryAssociation.custom.success });
        this.$router.push({ name: 'DeliveryList' });
      } else {
        this.displayToast({ message: "Une erreur est survenue", mode: 'error' });
      }
    }
  },
};
</script>

<style scoped>
.delivery .code { width: 30%; }
.delivery .quantity { width: 20%; }
.delivery .total { width: 15%; }

.bill .quantity-price { width: 20% }
.bill .total { width: 10% }
.bill .credit { width: 5% }

.center { text-align: center; }

.product-row {
  font-size: 1.2rem;
}

.quantity-price .quantity { width: 4rem }
.quantity-price .price { width: 6rem }

.f-table .space { padding-right: 5%; }

.credit .f-checkbox {
  width: 2rem;
}

.qty-error {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--app-red-color);
}

.total-prices {
  display: flex;
  flex-direction: column;
}

.total-prices > * {
  margin-bottom: 0 !important;
  line-height: 26px !important;
}

.txt-ternary {
  font-weight: 600;
  font-style: italic;
  letter-spacing: 1px;
}
</style>
<style>
.filepond--action-remove-item {
  display: none;
}
</style>
<style src="@/assets/styles/datepickers.css"></style>
<style scoped src="@/assets/styles/deliveries.css"></style>
<style src="@/assets/styles/filepond.css"></style>
